import React, { useState } from 'react';
import block from 'propmods';

import './Expander.scss';

const b = block('Expander');

interface Props {
    title: string;
    children: React.ReactNode;
    defaultExpanded?: boolean;
    type: 'doc' | 'default';
}

export const Expander: React.FC<Props> = ({ title, children, defaultExpanded, type }) => {
    const [expanded, setExpanded] = useState(Boolean(defaultExpanded));

    const toggleExpanded = () => setExpanded(!expanded);

    return (
        <div {...b({ type })}>
            <div {...b('title', { expanded })} onClick={toggleExpanded}>
                {title}
            </div>
            <div {...b('content', { expanded })}>{children}</div>
        </div>
    );
};
